import { useEffect, useState } from "react";
import {
  LoaderComponentProps,
  withLoader,
} from "../../../AppComponents/Loader";
import { ApiBoxWrapper, ApiLibraryWrap} from "../style";
import TopMenuComponent from "../common/TopBar";
import ApiCard from "../common/ApiAccordian";
import AppPaginationComponent from "../../../AppComponents/Pagination/Pagination";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { Box, debounce, Divider, Typography } from "@mui/material";
import NoRecordsFound from "../../UiComponents/NoRecordsFound/NoRecordsFound";
import { ProtectedAppButton } from "../../../AppComponents/ProtectedComponents";
import { AppMaterialIcons } from "../../../AppComponents/AppMaterialIcons";
import { useNavigate } from "react-router-dom";
import { TableWrapper } from "../../../TableStyle";
import AppModel from "../../../Hooks/useModel/AppModel";
import { webhookLibraryNetworkService } from "../../../Store/Slices/WebhookLibrary/webhookLibraryNetworkService";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import { useNotification } from "../../../Hooks/useNotification/useNotification";
import { selectWebhookList, selectWebhookPagination } from "../../../Store/Slices/WebhookLibrary/webhookLibrary.selectors";
import { WebhookLibraryNetworkActions } from "../../../Store/Slices/WebhookLibrary/webhookLibrary.actions";
interface Props extends LoaderComponentProps {}

const WebhookLibraryList: React.FC<Props> = ({ setLoading }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [localValues, setLocalValues] = useState<any>({
    itemsPerPage: { label: "50  per page", value: 50 },
    currentPage: 0,
    method: "",
    search: "",
  });
  const [deleteModel, setDeleteModel] = useState<any>({
    isOpen: false,
    webhookId: "",
  });
  // Fetch data from Redux store using selectors
  const webhookList = useAppSelector(selectWebhookList);
  const { showAlert } = useNotification();
  const webhookPagination = useAppSelector(selectWebhookPagination);

  const fetchWebhookList = () => {
    setLoading(true);
    let paylaod = {
      limit: localValues?.itemsPerPage?.value,
      offset: localValues?.currentPage,
      search: localValues?.search,
      method: localValues?.method,
    };
    // Dispatch action to fetch WEBHOOK data
    dispatch(WebhookLibraryNetworkActions.getWebhookList(paylaod)).finally(() => {
      // Set loading false after fetching data
      setLoading(false);
    });
  }
  useEffect(() => {
    // Set loader true before fetching data
    fetchWebhookList()
  }, [localValues]);

  const handleDeleteModal = (id: any) => {
    setDeleteModel({ isOpen: true, webhookId: id });
  };
  const handleDeleteWebhook = async (webhookId: string) => {
    webhookLibraryNetworkService.DeleteWebhook(webhookId)
      .then(() => {
        fetchWebhookList()
        setDeleteModel({ isOpen: false, webhookId: "" });
        showAlert("WEBHOOK Deleted Succesfully", "success");
      })
      .catch((error) => {
        setDeleteModel({ isOpen: false, webhookId: "" });
        showAlert(error?.response?.data?.response, "error");
      });
  };
  function handlePageChange(event: any, value: any) {
    setLocalValues({
      ...localValues,
      currentPage: value - 1,
    });
  }
  const handleChangeRowsPerPage = (value: any) => {
    setLocalValues({
      ...localValues,
      itemsPerPage: value,
      currentPage: 0,
    });
  };
  const handleChangeMethod = (value: any) => {
    setLocalValues({
      ...localValues,
      method: value.target.value,
      currentPage: 0,
    });
  };
  const handleSelectSearch = debounce((e?: any, field?: any) => {
    setLocalValues({
      ...localValues,
      search: e,
      currentPage: 0,
    });
  }, 700);

  return (
    <ApiLibraryWrap>
      <TopMenuComponent
        hideFilters={false}
        method={localValues?.method}
        handleChangeMethod={handleChangeMethod}
        handleSelectSearch={handleSelectSearch}
      />
      <ApiBoxWrapper>
        {webhookList?.length !== 0 ? (
          <TableWrapper>
            <div style={{ overflow: "auto", height: "calc(100vh - 210px)" }}>
              <Box className="table-header">
                <Box className="table-row">
                  {["Name", "Created Date", "Modified Date", "Action"].map(
                    (header, index) => (
                      <Box
                        className={`col-head ${header
                          .toLowerCase()
                          .replaceAll(" ", "_")}`}
                        style={{
                          minWidth: `${header === "Action" ? 100 : 150}px`,
                          border: "none",
                        }}
                        key={index}
                      >
                        <Typography sx={{ fontWeight: 500 }}>
                          {header}
                        </Typography>
                      </Box>
                    )
                  )}
                </Box>
                <Divider />
              </Box>

              <Box className="table-body">
                {webhookList?.map((webhook: any, index: any) => (
                  <ApiCard
                    handleDeleteModal={handleDeleteModal}
                    key={webhook.id}
                    api={webhook}
                  />
                ))}
              </Box>
            </div>
          </TableWrapper>
        ) : (
          <NoRecordsFound
            height="calc(100vh - 212px)"
            subText="Create New Broadcast"
          >
            <ProtectedAppButton
              moduleId="email_broadcast_crud"
              specificPermissionKey="create"
              variant="primarydark"
              onClick={() => navigate("/webhook/library/create")}
            >
              Create Webhook
              <AppMaterialIcons iconName="Add" />
            </ProtectedAppButton>
          </NoRecordsFound>
        )}
      </ApiBoxWrapper>
      {/* Pagination */}
      {webhookList?.length > 0 && (
        <AppPaginationComponent
          totalCount={webhookPagination?.totalRecords}
          handlePageChange={handlePageChange}
          currentPage={localValues?.currentPage}
          totalPages={webhookPagination?.totalPages}
          rowsPerPage={localValues?.itemsPerPage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
      \
      <AppModel
        width="600px"
        style={{ width: "100%" }}
        onClose={() => setDeleteModel({ isOpen: false, webhookId: "" })}
        isShowing={deleteModel.isOpen}
      >
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this webhook ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => setDeleteModel({ isOpen: false, webhookId: "" })}
          >
            Cancel
          </Button>
          <Button
            color="error"
            onClick={() => handleDeleteWebhook(deleteModel.webhookId)}
          >
            Delete
          </Button>
        </DialogActions>
      </AppModel>
    </ApiLibraryWrap>
  );
};

export default withLoader(WebhookLibraryList);
